<a (click)="downloadCard(policyNumber)" class="pointer-cursor">
  <div class="margin-bottom mb32 w280 h32">
    <img src="assets/img/images/apple-wallet.png" alt="apple wallet"/>
  </div>
  <div class="margin-bottom mb16">
    <img src="assets/img/images/android-pass.png" alt="android pass"/>
  </div>
</a>
<div class="wallet-android-passes margin-bottom mb8">
  {{ 'WALLETBACK_ANDROID' | translate }}
</div>
<a
  class="mapfre link blue-link underline"
  href="https://play.google.com/store/apps/details?id=io.walletpasses.android&hl=en_US">
  <span>{{ 'WALLETBACK_WALLETPASS' | translate }}</span>
</a>